import type { JobDataSummary } from '~/types'

export const getCurrencyFromCountry = (country: string) => {
  const countryCurrency: Record<string, string> = {
    'United States': 'USD',
    Poland: 'PLN',
    'Great Britain': 'GBP',
  }

  if (country in countryCurrency) {
    return countryCurrency[country]
  }

  return 'EUR'
}

export const removeDecimalFromSalary = (salary: string) => {
  return Number(salary)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

export const formatSalaryForDisplay = (position: JobDataSummary) => {
  if (!position.minimum_salary || !position.maximum_salary) {
    return null
  }

  return `${removeDecimalFromSalary(position.minimum_salary)} - ${removeDecimalFromSalary(position.maximum_salary)} ${getCurrencyFromCountry(position.country_id)}`
}
